/**
 * PATH: packages/ui/src/qa/QaItemStatusButtons.tsx
 * FILE_ID: UI-QA-ITEM-STATUS-BUTTONS-001
 * PURPOSE: Four QA verdict buttons with border-only selected colour.
 */

import { Check, X, AlertTriangle, MinusCircle } from 'lucide-react'
import { cn } from '../lib/utils'
import { QA_ITEM_STATUS_BUTTONS, isQaItemStatusSelected, type QaItemStatusWrite } from './qaItemStatus'

const ICONS = { pass: Check, fail: X, further_action: AlertTriangle, na: MinusCircle } as const

const SELECTED_BORDER = {
  pass: 'border-2 border-emerald-600 text-foreground',
  fail: 'border-2 border-red-600 text-foreground',
  further_action: 'border-2 border-orange-500 text-foreground',
  na: 'border-2 border-black dark:border-white text-foreground',
} as const

export function QaItemStatusButtons({
  currentStatus,
  disabled,
  onSelect,
}: {
  currentStatus: string
  disabled?: boolean
  onSelect: (status: QaItemStatusWrite) => void
}) {
  return (
    <div className="flex flex-wrap gap-1">
      {QA_ITEM_STATUS_BUTTONS.map((btn) => {
        const Icon = ICONS[btn.id]
        const selected = isQaItemStatusSelected(currentStatus, btn.selectedWhen)
        return (
          <button
            key={btn.id}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(btn.write)}
            aria-pressed={selected}
            aria-label={btn.label}
            className={cn(
              'inline-flex items-center gap-1 whitespace-nowrap rounded-md border px-2 py-1 text-[11px] font-medium bg-card',
              selected ? SELECTED_BORDER[btn.id] : 'border-border text-muted-foreground hover:text-foreground',
              disabled && 'opacity-50',
            )}
          >
            <Icon className="h-3 w-3" aria-hidden />
            {btn.label}
          </button>
        )
      })}
    </div>
  )
}
